function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "remove_svg__b",
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 24,
  rx: 12
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.499 12.499l-4.178 4.179 4.178-4.179-4.178-4.178 4.178 4.178 4.179-4.178-4.179 4.178 4.179 4.179z"
});

function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    stroke: "#aab4cb",
    fill: "none",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref2, _ref3);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyBzdHlsZT0ic3Ryb2tlOiAjYWFiNGNiOyBmaWxsOiBub25lOyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjUgMjUiPgogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMTggLTYwOCkiPgogICAgPGcgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxOCA2MDgpIj4KICAgICAgPHJlY3QgY2xhc3M9ImIiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHJ4PSIxMiIvPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCkiPgogICAgICA8cGF0aCBkPSJNNC4xNzgsNC4xNzgsMCw4LjM1Nyw0LjE3OCw0LjE3OCwwLDAsNC4xNzgsNC4xNzgsOC4zNTcsMCw0LjE3OCw0LjE3OCw4LjM1Nyw4LjM1N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMyMi4zMjEgNjE2LjMyMSkiLz48L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };